import { Component, Host, Prop, h, Element } from '@stencil/core';

@Component({
  tag: 'pn-cta-block',
  styleUrl: 'pn-cta-block.scss',
})
export class PnCtaBlock {
  @Element() hostElement: HTMLElement;

  @Prop() heading: string = null;
  @Prop() bodyText: string = null;

  @Prop() pnBackgroundColor: string = null;

  @Prop() isLarge: boolean = false;
  @Prop() isCentered: boolean = false;
  @Prop() isSmall: boolean = false;
  @Prop() contentTop: boolean = false;

  render() {
    const hasImage = this.hostElement.querySelector('[slot="illustration"]');
    const hasButtons = this.hostElement.querySelector('[slot="cta-buttons"]');
    return (
      <Host>
        <div pn-background-color={this.pnBackgroundColor} class={`cta-block ${this.isLarge ? 'cta-block--large' : ''}  ${this.isCentered ? 'cta-block--center' : ''}  ${(this.isSmall ? 'cta-block--small' : '')} ${this.contentTop ? 'cta-block--content-top' : ''}`}>
          {(hasImage ?
            <div class="cta-block__image-wrapper">
              <slot name="illustration" />
            </div> : null
          )}
          <div class="cta-block__content">
            {(this.heading) ? <h2 class="cta-block__heading">{this.heading}</h2> : null}
            {(this.bodyText) ? <p class="cta-block__text">{this.bodyText}</p> : null}
          </div>
          {(hasButtons ?
            <div class="cta-block__action">
              <slot name="cta-buttons" />
            </div> : null
          )}
        </div>
      </Host>
    );
  }
}
